<template>
  <div class="error-page">
    <!-- Animated background orbs -->
    <div class="bg-orb orb-1"></div>
    <div class="bg-orb orb-2"></div>
    <div class="bg-orb orb-3"></div>

    <div class="error-card">
      <!-- Gears animation -->
      <div class="gears-container">
        <div class="gear gear-one">
          <div class="gear-teeth"></div>
          <div class="gear-center"></div>
        </div>
        <div class="gear gear-two">
          <div class="gear-teeth"></div>
          <div class="gear-center"></div>
        </div>
        <div class="gear gear-three">
          <div class="gear-teeth"></div>
          <div class="gear-center"></div>
        </div>
      </div>

      <!-- Error code -->
      <div class="error-code">
        <span class="digit">5</span>
        <span class="digit highlight">0</span>
        <span class="digit">0</span>
      </div>

      <!-- Title & subtitle -->
      <h1 class="error-title">Server Error</h1>
      <p class="error-subtitle">
        Something went wrong on our end. Our team has been notified and is working to fix it.
      </p>

      <!-- Divider -->
      <div class="divider">
        <span class="divider-dot"></span>
        <span class="divider-dot"></span>
        <span class="divider-dot"></span>
      </div>

      <!-- Action buttons -->
      <div class="action-buttons">
        <button class="btn btn-primary" @click="goBack">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
          </svg>
          Go Back
        </button>
        <button class="btn btn-secondary" @click="reload">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
          </svg>
          Try Again
        </button>
      </div>

      <!-- Brand badge -->
      <div class="brand-badge">
        <span class="brand-icon">💎</span>
        <span class="brand-name">JewelBiz</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Error500',
  methods: {
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.push('/');
      }
    },
    reload() {
      window.location.reload();
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.error-page {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #0f0c29 0%, #302b63 50%, #24243e 100%);
  font-family: 'Inter', sans-serif;
  overflow: hidden;
  z-index: 9999;
}

/* ── Background animated orbs ── */
.bg-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
  opacity: 0.25;
  animation: floatOrb 8s ease-in-out infinite alternate;
}
.orb-1 {
  width: 500px; height: 500px;
  background: radial-gradient(circle, #c9a227, transparent);
  top: -150px; left: -100px;
  animation-delay: 0s;
}
.orb-2 {
  width: 400px; height: 400px;
  background: radial-gradient(circle, #7b2ff7, transparent);
  bottom: -100px; right: -80px;
  animation-delay: 3s;
}
.orb-3 {
  width: 300px; height: 300px;
  background: radial-gradient(circle, #e91e8c, transparent);
  top: 50%; left: 50%;
  transform: translate(-50%, -50%);
  animation-delay: 1.5s;
}

@keyframes floatOrb {
  0%   { transform: translate(0, 0) scale(1); }
  100% { transform: translate(30px, 30px) scale(1.1); }
}

/* ── Glassmorphism card ── */
.error-card {
  position: relative;
  background: rgba(255, 255, 255, 0.06);
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 28px;
  padding: 48px 56px;
  max-width: 520px;
  width: 90%;
  text-align: center;
  box-shadow:
    0 32px 64px rgba(0, 0, 0, 0.4),
    inset 0 1px 0 rgba(255,255,255,0.1);
  animation: cardIn 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) both;
}

@keyframes cardIn {
  from { opacity: 0; transform: translateY(40px) scale(0.95); }
  to   { opacity: 1; transform: translateY(0) scale(1); }
}

/* ── Gears ── */
.gears-container {
  position: relative;
  height: 100px;
  margin-bottom: 24px;
}

.gear {
  position: absolute;
  border-radius: 50%;
}

.gear-teeth {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  border: 6px solid #c9a227;
  /* create teeth via box-shadow */
}

.gear-center {
  position: absolute;
  inset: 22%;
  border-radius: 50%;
  background: rgba(201, 162, 39, 0.2);
  border: 3px solid #c9a227;
}

/* Draw gear teeth using the gear bar technique */
.gear {
  background: rgba(201, 162, 39, 0.15);
  border: 4px solid #c9a227;
  position: absolute;
}

.gear::before,
.gear::after {
  content: '';
  position: absolute;
  background: #c9a227;
  border-radius: 3px;
  top: 50%;
  left: 50%;
  transform-origin: center;
}
/* horizontal bar */
.gear::before {
  width: 130%;
  height: 22%;
  top: 39%;
  left: -15%;
}
/* vertical bar */
.gear::after {
  width: 22%;
  height: 130%;
  top: -15%;
  left: 39%;
}

.gear-one {
  width: 72px; height: 72px;
  border-radius: 50%;
  left: calc(50% - 100px);
  top: 14px;
  animation: spin-cw 4s linear infinite;
}
.gear-two {
  width: 56px; height: 56px;
  border-radius: 50%;
  left: calc(50% - 28px);
  top: 22px;
  animation: spin-ccw 3s linear infinite;
  border-color: #e91e8c;
  background: rgba(233, 30, 140, 0.1);
}
.gear-two::before, .gear-two::after { background: #e91e8c; }

.gear-three {
  width: 62px; height: 62px;
  border-radius: 50%;
  left: calc(50% + 44px);
  top: 18px;
  animation: spin-cw 3.5s linear infinite;
  border-color: #7b2ff7;
  background: rgba(123, 47, 247, 0.1);
}
.gear-three::before, .gear-three::after { background: #7b2ff7; }

@keyframes spin-cw  { to { transform: rotate(360deg); } }
@keyframes spin-ccw { to { transform: rotate(-360deg); } }

/* ── Error code ── */
.error-code {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  margin-bottom: 16px;
}
.digit {
  font-size: 6rem;
  font-weight: 800;
  line-height: 1;
  color: rgba(255,255,255,0.85);
  letter-spacing: -4px;
  text-shadow: 0 0 40px rgba(201,162,39,0.3);
}
.digit.highlight {
  background: linear-gradient(135deg, #c9a227 0%, #f5d06b 50%, #c9a227 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-shadow: none;
  filter: drop-shadow(0 0 20px rgba(201,162,39,0.6));
}

/* ── Text ── */
.error-title {
  font-size: 1.6rem;
  font-weight: 700;
  color: #fff;
  margin-bottom: 12px;
  letter-spacing: -0.5px;
}
.error-subtitle {
  font-size: 0.95rem;
  color: rgba(255,255,255,0.55);
  line-height: 1.7;
  max-width: 360px;
  margin: 0 auto;
}

/* ── Divider dots ── */
.divider {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin: 28px 0;
}
.divider-dot {
  display: inline-block;
  width: 6px; height: 6px;
  border-radius: 50%;
  background: rgba(255,255,255,0.2);
}
.divider-dot:nth-child(2) {
  background: #c9a227;
  transform: scale(1.3);
}

/* ── Buttons ── */
.action-buttons {
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
}
.btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 26px;
  border-radius: 50px;
  font-family: 'Inter', sans-serif;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: all 0.25s ease;
  text-decoration: none;
}
.btn-primary {
  background: linear-gradient(135deg, #c9a227, #f5d06b);
  color: #1a1200;
  box-shadow: 0 8px 24px rgba(201,162,39,0.35);
}
.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 32px rgba(201,162,39,0.5);
}
.btn-primary:active { transform: translateY(0); }

.btn-secondary {
  background: rgba(255,255,255,0.08);
  color: rgba(255,255,255,0.8);
  border: 1px solid rgba(255,255,255,0.15);
}
.btn-secondary:hover {
  background: rgba(255,255,255,0.14);
  transform: translateY(-2px);
}
.btn-secondary:active { transform: translateY(0); }

/* ── Brand badge ── */
.brand-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 32px;
  padding: 6px 16px;
  background: rgba(255,255,255,0.05);
  border: 1px solid rgba(255,255,255,0.08);
  border-radius: 50px;
}
.brand-icon { font-size: 0.9rem; }
.brand-name {
  font-size: 0.8rem;
  font-weight: 600;
  color: rgba(255,255,255,0.4);
  letter-spacing: 1px;
  text-transform: uppercase;
}
</style>
